<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitRequest)">
        <div class="breadcrumb-area pos-relative w-100">
          <h1>Sửa TT quản lý</h1>
          <div style="float: right">
            <button type="button" @click="backToDetailTicket()" class="btn btn-light">
              Hủy bỏ
            </button>
            <button @click="editManage" class="btn btn-success btn-primary ml-2">Lưu</button>
          </div>
        </div>
        <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: hidden; overflow-y: auto">
          <div class="card-body px-20 row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Bộ phận vừa xử lý</label>
                <Select2
                  v-model="dataRequest.workUnit"
                  :options="dataDepartment"
                  placeholder="Chọn bộ phận vừa xử lý"
                />
              </div>
              <div class="form-group">
                <label>Bộ phận đang xử lý</label>
                <Select2
                  v-model="dataRequest.workingUnit"
                  :options="dataDepartment"
                  placeholder="Chọn bộ phận đang xử lý"
                />
              </div>

              <div class="form-group">
                <label>Mức độ ưu tiên</label>
                <Select2
                  v-model="dataRequest.workPriority"
                  :options="dataPriority"
                  placeholder="Chọn mức độ ưu tiên"
                />
              </div>
              <div class="form-group">
                <label>Loại công việc</label>
                <Select2
                  v-model="dataRequest.workType"
                  :options="dataWorkType"
                  placeholder="Chọn loại công việc"
                />
              </div>
              <div class="form-group">
                <label>Thời hạn bước hiện tại</label>
                <v-date-picker
                  :popover="{ visibility: 'click', positionFixed: true }"
                  v-model="workingStepTime"
                  mode="dateTime"
                  locale="vi-VN"
                  is24hr
                  :attributes="[{ dot: true, dates: new Date() }]"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input readonly :value="inputValue || '---'" v-on="inputEvents" />
                  </template>
                </v-date-picker>
              </div>
              <div class="form-group">
                <label>Thời hạn ticket</label>
                <v-date-picker
                  :popover="{ visibility: 'click', positionFixed: true }"
                  v-model="ticketDeadline"
                  mode="dateTime"
                  locale="vi-VN"
                  is24hr
                  :attributes="[{ dot: true, dates: new Date() }]"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input readonly :value="inputValue || '---'" v-on="inputEvents" />
                  </template>
                </v-date-picker>
              </div>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
    <modalManageInfo />
  </div>
</template>

<script>
  import { TicketService } from '@/services/ticket.service'
  import Config from '@/thirdParty/config'
  import InputRange from '@/components/InputRange.vue'
  import modalManageInfo from './modalManageInfo.vue'
  import moment from 'moment'
  import { pick } from 'lodash'
  export default {
    name: 'edit-manage-info',
    data() {
      return {
        Config,
        showLoading: false,
        dataRequest: {},
        dataDepartment: [],
        dataWorkType: [],
        dataPriority: [],
        ticketDeadline: null,
        workingStepTime: null,
        item: {},
      }
    },
    components: { InputRange, modalManageInfo },
    created() {
      TicketService.getListDepartment()
        .then(s => s.data.data)
        .then(s => Object.keys(s).map(key => ({ id: key, text: s[key] })))
        .then(s => (this.dataDepartment = s))
      TicketService.getListWorkType()
        .then(s => s.data.data)
        .then(s => Object.keys(s).map(key => ({ id: key, text: s[key] })))
        .then(s => (this.dataWorkType = s))
      TicketService.getListPriority()
        .then(s => s.data.data)
        .then(s => Object.keys(s).map(key => ({ id: key, text: s[key] })))
        .then(s => (this.dataPriority = s))
      this.fetchData()
    },
    methods: {
      async submitRequest() {},
      backToDetailTicket() {
        this.$router.push({
          path: `/ticket/${this.$route.params.id}`,
        })
      },
      async editManage() {
        try {
          this.showLoading = true
          const data = {
            ticketDeadline: moment(this.ticketDeadline).valueOf(),
            workingStepTime: moment(this.workingStepTime).valueOf(),
            ticketId: this.$route.params.id,
            ...this.dataRequest,
          }
          const response = await TicketService.updateManageInfo(data)
          if (response.success) {
            this.showSuccessMx('Sửa thông tin quản lý thành công').then(() =>
              this.backToDetailTicket()
            )
          } else this.showFailMx(response.message)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async fetchData() {
        try {
          this.showLoading = true
          const res = await TicketService.getOne({ ticketId: this.$route.params.id })
          this.dataRequest = {
            workUnit: res.data.workUnit,
            workPriority: res.data.workPriority,
            workType: res.data.workType,
            workingUnit: res.data.workingUnit,
          }
          this.ticketDeadline = res.data.ticketDeadline
          this.workingStepTime = res.data.workingStepTime
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped></style>
